import React from "react";
// import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
// import { Tabs, TabList } from 'react-tabs';
// import { Link } from 'react-router-dom';
import { Element, scroller } from "react-scroll";

import FeaturedProductsOne from "../../common/product-groups/featured-products-one";
import TabListItem from "./tab-list-item";

// import { removeXSSAttacks } from '../../../../../utils';

function SingleTab(props) {
  const { addClass = "", dataProduct, isLoading } = props;

  function scrollTo(id) {
    scroller.scrollTo(`${id}`, {
      duration: 800,
      delay: 0,
      smooth: "easeInOutQuart",
    });
  }

  return (
    <>
      <div className="skel-pro skel-extended-detail mb-5"></div>
      {isLoading === false ? (
        <div className={`product-single-tabs ${addClass}`}>
          {dataProduct.product_variant_description ||
          dataProduct.product_description ? (
            <Element name="description">
              <TabListItem
                dataProduct={dataProduct}
                type="description"
                scrollTo={scrollTo}
              />

              {dataProduct.product_variant_description ? (
                <div className="tab-pane fade show">
                  <div className="product-desc-content pt-4">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: dataProduct.product_variant_description,
                      }}
                      style={{ fontSize: "1.4rem" }}
                    ></div>
                  </div>
                </div>
              ) : dataProduct.product_description ? (
                <div className="tab-pane fade show">
                  <div className="product-desc-content pt-4">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: dataProduct.product_description,
                      }}
                      style={{ fontSize: "1.4rem" }}
                    ></div>
                  </div>
                </div>
              ) : null}
            </Element>
          ) : null}

          {(dataProduct.product && dataProduct.product.features.length > 0) ||
          (dataProduct.features && dataProduct.features.length > 0) ? (
            <Element name="features">
              <TabListItem
                dataProduct={dataProduct}
                type="features"
                scrollTo={scrollTo}
              />

              {dataProduct.product ? (
                dataProduct.product.features.length > 0 ? (
                  <div className="tab-pane fade show">
                    <div className="product-size-content">
                      <div className="row">
                        <div className="col-md-12">
                          <table className="table table-size">
                            {/* <thead>
                                    <tr>
                                      <th>SIZE</th>
                                      <th>CHEST (in.)</th>
                                    </tr>
                                  </thead> */}
                            <tbody>
                              {dataProduct.product.features.map((feature) => (
                                <tr key={feature.product_feature_id}>
                                  <td>{feature.features.feature_name}</td>
                                  <td>{feature.product_feature_value}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null
              ) : dataProduct.features.length > 0 ? (
                <div className="tab-pane fade show">
                  <div className="product-size-content">
                    <div className="row">
                      <div className="col-md-12">
                        <table className="table table-size">
                          <tbody>
                            {dataProduct.features.map((feature) => (
                              <tr key={feature.product_feature_id}>
                                <td>{feature.features.feature_name}</td>
                                <td>{feature.product_feature_value}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </Element>
          ) : null}

          {dataProduct.product_variant_delivery_description ||
          dataProduct.product_delivery_description ? (
            <Element name="delivery">
              <TabListItem
                dataProduct={dataProduct}
                type="delivery"
                scrollTo={scrollTo}
              />

              {(dataProduct.product_variant_delivery_description ||
                dataProduct.product_delivery_description) && (
                <div className="tab-pane fade show">
                  <div className="product-desc-content pt-4">
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          dataProduct.product_variant_delivery_description ||
                          dataProduct.product_delivery_description,
                      }}
                      style={{ fontSize: "1.4rem" }}
                    ></div>
                  </div>
                </div>
              )}
            </Element>
          ) : null}

          {(dataProduct.product && dataProduct.product.related.length > 0) ||
          (dataProduct.related && dataProduct.related.length > 0) ? (
            <Element name="relation">
              <TabListItem
                dataProduct={dataProduct}
                type="relation"
                scrollTo={scrollTo}
              />

              <FeaturedProductsOne
                addClass="pt-4 mb-5"
                dataProduct={dataProduct}
              />
            </Element>
          ) : null}

          {/* <Element name="opinion">
              <TabList className="nav nav-tabs nav-border-anim">
                {
                  dataProduct.product_variant_description ?
                    <li className="nav-link" onClick={() => scrollTo('description')}>Opis</li>
                  : dataProduct.product_description ?
                    <li className="nav-link" onClick={() => scrollTo('description')}>Opis</li>
                  : null
                }
                {
                  dataProduct.product ?
                    dataProduct.product.features.length > 0 ?
                      <li className="nav-link" onClick={() => scrollTo('features')}>Dane techniczne</li>
                    : null
                  : dataProduct.features.length > 0 ?
                    <li className="nav-link" onClick={() => scrollTo('features')}>Dane techniczne</li>
                  : null
                }
                <li className="nav-link active" onClick={() => scrollTo('opinion')}>Opinie</li>
              </TabList>

              <div className="tab-pane fade show">
                <div className="product-reviews-content">
                  <div className="row">
                    <div className={dataProduct.product ? dataProduct.product.comments.length > 0 ? "col-xl-7" : "col-xl-12" : dataProduct.comments.length > 0 ? "col-xl-7" : "col-xl-12"}>
                      <ol className="comment-list">
                        {
                          dataProduct.product ?
                            dataProduct.product.comments.length > 0 ?
                              <>
                                {
                                  dataProduct.product.comments.map(item => (
                                    <li className="comment-container" key={item.comment_id}>
                                      <div className="comment-avatar">
                                        <img src={process.env.PUBLIC_URL + '/assets/images/avatar/avatar1.jpg'} width="65" height="65" alt="avatar" />
                                      </div>
                                      <div className="comment-box">
                                        <div className="ratings-container">
                                          <div className="product-ratings">
                                            <span className="ratings" style={{ width: 20 * item.comment_score + '%' }}></span>
                                          </div>
                                        </div>
                                        <div className="comment-info mb-1">
                                          <span>
                                            <h4 className="avatar-name">{item.user ? item.user.name + ' ' + item.user.last_name : ''}</h4> - <span className="comment-date">{item.comment_created_at}</span>
                                          </span>
                                        </div>
                                        <div className="comment-text">
                                          <p>{item.comment_content}</p>
                                        </div>
                                      </div>
                                    </li>
                                  ))
                                }
                              </>
                              : <h2 className="reviews-title pt-4">Bądź pierwszą osobą, która oceni ten produkt.</h2>
                            :
                            dataProduct.comments.length > 0 ?
                              <>
                                {
                                  dataProduct.comments.map(item => (
                                    <li className="comment-container" key={item.comment_id}>
                                      <div className="comment-avatar">
                                        <img src={process.env.PUBLIC_URL + '/assets/images/avatar/avatar1.jpg'} width="65" height="65" alt="avatar" />
                                      </div>
                                      <div className="comment-box">
                                        <div className="ratings-container">
                                          <div className="product-ratings">
                                            <span className="ratings" style={{ width: 20 * item.comment_score + '%' }}></span>
                                          </div>
                                        </div>
                                        <div className="comment-info mb-1">
                                          <span>
                                            <h4 className="avatar-name">{item.user ? item.user.name + item.user.last_name : ''}</h4> - <span className="comment-date">{item.comment_created_at}</span>
                                          </span>
                                        </div>
                                        <div className="comment-text">
                                          <p>{item.comment_content}</p>
                                        </div>
                                      </div>
                                    </li>
                                  ))
                                }
                              </>
                              : <h2 className="reviews-title pt-4">Bądź pierwszą osobą, która oceni ten produkt.</h2>
                        }
                      </ol>
                    </div>
                    <div className={dataProduct.product ? dataProduct.product.comments.length > 0 ? "col-xl-5" : "col-xl-12" : dataProduct.comments.length > 0 ? "col-xl-5" : "col-xl-12"}>
                      <div className="add-product-review">
                        <form action="#" className="comment-form m-0">
                          <h3 className="review-title">Dodaj opinię</h3>

                          <div className="rating-form">
                            <label htmlFor="rating">Jak oceniasz ten produkt?</label>
                            <span className="rating-stars">
                              <Link className="star-1" to="#">1</Link>
                              <Link className="star-2" to="#">2</Link>
                              <Link className="star-3" to="#">3</Link>
                              <Link className="star-4" to="#">4</Link>
                              <Link className="star-5" to="#">5</Link>
                            </span>
                          </div>
                          <div className="form-group">
                            <label>Twoja opinia</label>
                            <textarea cols="5" rows="6" type="text" className="form-control form-control-sm" required />
                          </div>
                          <div className="row">
                            <div className="col-md-6 col-xl-12">
                              <div className="form-group">
                                <label>Twoje imię</label>
                                <input type="text" className="form-control form-control-sm" required />
                              </div>
                            </div>
                          </div>
                          <input type="submit" className="btn btn-dark ls-n-15" value="Dodaj opinię" />
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Element> */}
        </div>
      ) : null}
    </>
  );
}

export default SingleTab;
